export const SUPPLIER_GROUP_ID = 14;
export const isSupplier = (idGroup: number | null) => {
  return idGroup === SUPPLIER_GROUP_ID;
};
